import { ModalService, DialogInterface } from './providers/modal-service/ModalService';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SportifWebRoutingModule } from './app-routing.module';
import { SkeletonServiceService } from './components/skeleton-service.service';
import { DomService } from './providers/modal-service/DOMService';
import { UserManagerService } from './providers/services/userManager/user-manager.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpService } from './wrappers/Http';
import { TimeHandlerService } from './providers/time-handler.service';
import { LayoutsModule } from './components/layouts/layouts.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StorageService } from './providers/storage.service';
import { WebsocketService } from './providers/WebsocketService';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ConfigService } from './providers/config/config.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {MatDialogModule} from '@angular/material/dialog';
import { AuthService } from './providers/auth.service';
import { CurrencyFormatterPipe } from './pipes/currency-formatter.pipe';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './providers/paginator/custom-paginator';
import { ComponentsModule } from './components/components.module';
// import { UrlNormalizerService } from './providers/initializers/url-normalizer.service';
import { RouterModule } from '@angular/router';
import { APP_ROUTES } from './app.routes';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

// export function initUrlNormalizer(urlNormalizer: UrlNormalizerService) {
//   console.log('UrlNormalizerService instance:', urlNormalizer);
//   return () => urlNormalizer.normalizeAndRedirect();
// }

@NgModule({
  declarations: [
    AppComponent,
    DialogInterface
  ],
  entryComponents:[DialogInterface],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    LayoutsModule,
    HttpClientModule,
    ComponentsModule,
    MatDialogModule,
    // RouterModule.forRoot(APP_ROUTES),
    SportifWebRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production || environment.staging }),
  ],
  providers: [StorageService, TranslateService, SkeletonServiceService,    AuthService,
    ModalService, UserManagerService, DomService, TimeHandlerService, HttpService,
    WebsocketService, CurrencyFormatterPipe,ConfigService,
     {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initUrlNormalizer,
    //   deps: [UrlNormalizerService],
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
